<!-- DgssOrderForm -->

<template>
  <div v-if="dis_rules.can_take || dis_rules.can_ship || dis_rules.can_same">
    <div style="padding-bottom: 10px">
      <div style=" font-size: 15px; padding-top: 20px; padding-bottom: 10px; font-weight: 500; ">
        收费附件
      </div>
      <div v-for="e in charges" :key="e.id" style="display: flex; justify-content: space-between">
        <div>{{ e.name }}</div>
        <div style="display: flex">
          <div style="padding-right: 20px">{{ e.price }}</div>
          <van-stepper v-model="e.charge_count" theme="round" button-size="18" :min="0" @change="on_count_change" />
        </div>
      </div>
    </div>

    <div style="color: red">{{ dis_rules.delivery_text }}</div>

    <van-tabs v-model="dis_type">
      <van-tab title="门店自提" :disabled="dis_rules.can_take < 1">
        <van-popup v-model="show_popup" position="right" class="shop-select-popup">
          <div v-for="e in shop_lists.shops" :key="e.shop_id" @click="on_select_shop(e)" class="shop-selected-div">
            <div>{{ e.shop_name }}</div>
            <div>{{ e.phone }}</div>
            <div>{{ e.address }}</div>
          </div>
        </van-popup>

        <div v-if="selected_shop" @click="show_popup = true" class="shop-selected-div">
          <div>{{ selected_shop.shop_name }}</div>
          <div>{{ selected_shop.phone }}</div>
          <div>{{ selected_shop.address }}</div>
        </div>
        <div v-else @click="show_popup = true">
          <van-button style="width: 94vw; margin-top: 20px">点我选择门店</van-button>
        </div>

        <van-tree-select v-if="selected_shop" :items="take_dates" :main-active-index.sync="take_idx"
          :active-id.sync="take_act" @click-item="on_take_act" />
      </van-tab>

      <van-tab title="商家配送" :disabled="dis_rules.can_ship < 1">
        <van-tree-select :items="delivery_dates" :main-active-index.sync="delivery_idx" :active-id.sync="delivery_act"
          @click-item="on_delivery_act" />
      </van-tab>

      <van-tab title="快递配送" :disabled="dis_rules.can_same < 1">
        <van-button @click="on_same" style="width: 94vw; margin-top: 20px">
          运费 {{ dis_rules.validate_same_row.delivery_amount }},
          点我确认通过快递配送
        </van-button>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import request from "@/util/axios";

export default {
  props: ["goodsDetail"],

  data() {
    return {
      dis_type: -1,
      dis_rules: {},

      take_dates: [],
      take_idx: 0,
      take_act: 0,

      delivery_dates: [],
      delivery_idx: 0,
      delivery_act: 0,

      shop_lists: {},
      selected_shop: null,
      show_popup: false,

      charges: [],
    };
  },

  mounted() {
    this.init_option_dgss();

    this.dgss_product_detail();
  },

  methods: {
    on_count_change() {
      // this.dis_type 0 门店自提 1 商家配送
      if (this.dis_type == 0) {
        this.on_take_act();
        return;
      }

      if (this.dis_type == 1) {
        this.on_delivery_act();
        return;
      }

      this.on_same();
    },

    dgss_product_detail() {
      budo_log.info("#98 dgss_product_detail", this.goodsDetail);

      request.post_form("/v5/dgss-product-detail", {
        goodsId: this.goodsDetail.goodsId,
      }).then((res) => {
        this.charges = res?.data?.charges || [];
        this.charges.forEach((e) => (e.charge_count = 0));
      });
    },

    on_select_shop(e) {
      this.selected_shop = e;
      this.show_popup = false;
    },

    get_shop_lists() {
      request.post_form("/v5/dgss-shop-lists", {
        goodsId: this.goodsDetail.goodsId,
      }).then((res) => {
        this.shop_lists = res.data;
      });
    },

    on_same() {
      budo_log.info("#126 on_same");

      this.$emit("paySetup", {
        dis_type: "same",
        charges: this.charges,
      });

      $budo_toast("已选择通过快递配送");
    },

    on_delivery_act() {
      budo_log.info(
        "#44 on_delivery_act",
        this.delivery_dates,
        this.delivery_idx,
        this.delivery_act
      );

      if (!this.delivery_act) {
        this.$emit("paySetup", {
          dis_type: "delivery",
          charges: this.charges,
        });
        return;
      }

      var split = this.delivery_act.split("-");

      var date = this.delivery_dates[Number(split[0])].date;
      var time =
        this.delivery_dates[Number(split[0])].children[Number(split[1])].time;

      budo_log.info("#50 on_delivery_act, date=", date, "time=", time);

      this.$emit("paySetup", {
        dis_type: "delivery",
        ship_date: date,
        ship_time_text: time,
        charges: this.charges,
      });

      $budo_toast("已选择配送时间");
    },

    on_take_act() {
      budo_log.info(
        "#61 on_take_act",
        this.take_dates,
        this.take_idx,
        this.take_act
      );

      if (!this.take_act) {
        this.$emit("paySetup", {
          dis_type: "take",
          charges: this.charges,
        });
        return;
      }

      var split = this.take_act.split("+");
      var date = this.take_dates[Number(split[0])].date;
      var time = this.take_dates[Number(split[0])].children[Number(split[1])].time;

      budo_log.info("#67 on_take_act, date=", date, "time=", time);

      this.$emit("paySetup", {
        dis_type: "take",
        ship_date: date,
        ship_time_text: time,
        shop_id: this.selected_shop.shop_id,
        shop_name: this.selected_shop.shop_name,
        shop_address: this.selected_shop.address,
        charges: this.charges,
      });

      $budo_toast("已选择提货时间");
    },

    init_option_dgss() {
      budo_log.info("#111 init_option_dgss, goodsDetail=", this.goodsDetail);

      request.post_form("/v5/dgss-distribution-rules", {
        goodsId: this.goodsDetail.goodsId,
        spec: this.goodsDetail.spec,
      }).then((res) => {
        budo_log.info("#113 dgss-distribution-rules", res);

        if (res?.code != 200) {
          $budo_alert(res?.msg || "获取商品配送规则失败");
          return
        }

        this.dis_rules = res.data || {};

        if (res?.data?.can_take == "0" &&
          res?.data?.can_ship == "0" &&
          res?.data?.can_same == "0"
        ) {
          $budo_alert("此品牌不支持当前城市");
          return;
        }

        // 到店
        this.take_dates = this.dis_rules.validate_take_dates
          ?.slice(0, 3)
          ?.map((e, idy) => {
            return {
              text: e.date_text,
              date: e.date,
              children: e.validate_take_times.map((t, idx) => {
                return {
                  time: t,
                  text: t,
                  id: idy + "+" + idx,
                };
              }),
            };
          });

        // 商家配送
        this.delivery_dates = this.dis_rules.validate_delivery_dates
          ?.slice(0, 3)
          ?.map((e, idy) => {
            return {
              text: e.date_text,
              date: e.date,
              children: e.validate_delivery_times.map((t, idx) => {
                return {
                  time: t,
                  text: t + " 运费 " + e.delivery_amount,
                  id: idy + "-" + idx,
                };
              }),
            };
          });

        // 可到店的 拉取店铺地址
        if (this.dis_rules.can_take) {
          this.get_shop_lists();
        }
      });
    },
  },
};
</script>

<style scoped>
.shop-selected-div {
  border: solid #d6d6d6 1px;
  padding: 5px;
  margin-top: 5px;
  border-radius: 5px;
  background: #f5f5f5;
}

.shop-select-popup {
  /* :style="{ width: '85vw', height: '100vh' }" */
  width: 85vw;
  height: 100vh;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
